import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  tabContent: {
    marginTop: theme.spacing(1.5),    // ✅ Reducido de 2 a 1.5
  },
  // ✅ OPTIMIZADO: SectionHeader más compacto
  sectionHeader: {
    marginBottom: theme.spacing(1.5), // ✅ Reducido de 2 a 1.5
    padding: theme.spacing(1.5),      // ✅ Reducido de 2 a 1.5
    backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : theme.palette.grey[300]}`,
  },
  // ✅ OPTIMIZADO: CheckboxSection más compacto
  checkboxSection: {
    marginBottom: theme.spacing(2),   // ✅ Reducido de 3 a 2
    padding: theme.spacing(1.5),      // ✅ Reducido de 2 a 1.5
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : theme.palette.divider}`,
  },
  fieldGroup: {
    marginTop: theme.spacing(1.5),    // ✅ Reducido de 2 a 1.5
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    minWidth: 200,
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ NUEVO: TextField compacto para campos numéricos
  textFieldCompact: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      height: '40px', // ✅ Altura reducida
      "& input": {
        padding: '8px 12px', // ✅ Padding reducido
        fontSize: '0.875rem', // ✅ Fuente más pequeña
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: '0.875rem', // ✅ Label más pequeño
      transform: 'translate(14px, 12px) scale(1)', // ✅ Ajuste para label más pequeño
      "&.MuiInputLabel-shrink": {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: '0.75rem', // ✅ Helper text más pequeño
      marginTop: '4px',
    },
  },
  // ✅ NUEVO: FormControl compacto para Selects
  formControlCompact: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      height: '40px', // ✅ Altura reducida
      "& .MuiSelect-select": {
        padding: '8px 12px', // ✅ Padding reducido
        fontSize: '0.875rem', // ✅ Fuente más pequeña
        minHeight: 'auto', // ✅ Eliminar minHeight
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      fontSize: '0.875rem', // ✅ Label más pequeño
      transform: 'translate(14px, 12px) scale(1)',
      "&.MuiInputLabel-shrink": {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      padding: '6px 12px', // ✅ Padding reducido en menu items
      fontSize: '0.875rem', // ✅ Fuente más pequeña
      minHeight: '36px', // ✅ Altura reducida
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  // ✅ CORREGIDO: DialogContent dinámico según tema
  dialogContent: {
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
  },
  // ✅ CORREGIDO: DialogActions dinámico según tema
  dialogActions: {
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
    borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : theme.palette.divider}`,
  },
  // ✅ OPTIMIZADO: TabPanel más compacto
  tabPanel: {
    padding: theme.spacing(2),        // ✅ Reducido de 3 a 2
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
  },
  // ✅ NUEVO: Estilos para hacer componentes Select personalizados más compactos
  compactSelectWrapper: {
    "& .MuiFormControl-root": {
      "& .MuiOutlinedInput-root": {
        height: '40px', // ✅ Altura reducida
        "& .MuiSelect-select": {
          minHeight: 'auto !important', // ✅ Eliminar minHeight de 50px
          padding: '8px 12px !important', // ✅ Padding reducido
          fontSize: '0.875rem !important', // ✅ Fuente más pequeña
          display: 'flex',
          alignItems: 'center',
        },
      },
      "& .MuiInputLabel-root": {
        fontSize: '0.875rem', // ✅ Label más pequeño
        transform: 'translate(14px, 12px) scale(1)',
        "&.MuiInputLabel-shrink": {
          transform: 'translate(14px, -6px) scale(0.75)',
        },
      },
      "& .MuiChip-root": {
        height: '24px', // ✅ Chips más pequeños
        fontSize: '0.75rem', // ✅ Fuente más pequeña
        "& .MuiChip-label": {
          padding: '4px 8px', // ✅ Padding reducido
        },
      },
    },
  },
  // ✅ NUEVO: Bloque visual para FlowBuilder en Connections
  flowbuilderCard: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.mode === "dark" ? "#4B5563" : theme.palette.primary.light}`,
    backgroundColor: theme.mode === "dark" ? "#111827" : "#f5f9ff"
  },
  flowbuilderHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1)
  },
  flowbuilderTitle: {
    fontSize: "0.95rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  flowbuilderBody: {
    fontSize: "0.8rem"
  },
  flowbuilderChips: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1)
  },
  flowbuilderActions: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1)
  },
}));

export default useStyles;
